export default "__VITE_ASSET__ON_WLfau__"